export default "__VITE_ASSET__92p3NWKg__"